import api from "../../utils/apiUser";

export const getRoles = async () => {
  const res = await api.get("/api/roles");
  return res.data.roles; 
};
export const createRole = async (data) => {
  const res = await api.post("/api/roles", data);
  return res.data;
};

export const updateRole = async (id, data) => {
  const res = await api.put(`/api/roles/${id}`, data);
  return res.data;
};